
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 17.408V7.592H9.026V6.5H12v11.998H0V6.501h3.023v1.09H1.001v9.817h9.998zm-8.272-12.7l-.705-.705L6.025 0l4.003 4.003-.71.71-2.793-2.797v10.515h-1V1.916L2.728 4.708z"}})])
          )
        }
      }
    